import React from 'react';
import { Card } from '@dopomogai/ui';

type Props = {
  count?: number;
  className?: string;
};

export function QuoteListSkeleton({ count = 10, className }: Props) {
  return (
    <div className={className}>
      {Array.from({ length: count }).map((_, i) => (
        <Card key={i} noHoverEffect className="mb-4">
          <div className="p-4 animate-pulse">
            <div className="flex items-center justify-between gap-4">
              <div>
                <div className="h-4 w-40 bg-slate-200 rounded mb-2" />
                <div className="h-3 w-28 bg-slate-200 rounded" />
              </div>
              <div className="flex items-center gap-6">
                <div className="h-5 w-20 bg-slate-200 rounded" />
                <div className="h-6 w-16 bg-slate-200 rounded" />
                <div className="h-9 w-28 bg-slate-200 rounded" />
              </div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
